import { http } from "msw";
import type { Job, JobType, Page } from "../../api/types";
import { getCollection } from "../db";
import { paginateCursor, search } from "../engine";
import { decorateCreatorSummary, mockJson } from "./shared";

export const jobsHandlers = [
  http.get("/api/jobs", async ({ request }) => {
    const url = new URL(request.url);
    const q = url.searchParams.get("q") ?? "";
    const type = url.searchParams.get("type") as JobType | null;
    const cursor = url.searchParams.get("cursor");
    const limit = Number(url.searchParams.get("limit") ?? 20) || 20;

    let jobs = await getCollection<Job>("jobs");
    jobs = search(jobs, q, [(j) => j.title, (j) => j.description, (j) => j.skills, (j) => j.poster.username]);
    if (type) jobs = jobs.filter((j) => j.type === type);

    const page = paginateCursor(jobs, cursor, limit);
    const body: Page<Job> = {
      items: page.items.map((job) => ({ ...job, poster: decorateCreatorSummary(job.poster) })),
      nextCursor: page.nextCursor,
    };
    return mockJson(body);
  }),
];
